import type React from 'react';

import { Row, Col, Button } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DataGrid from 'components/theme_components/DataGrid';
import HeroTitle from 'components/theme_components/HeroTitle';
import DF from 'DisplayFramework';
import {
  DownloadOutlined,
  PlusOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { useContext, useState } from 'react';
import Notifications from 'components/theme_components/Notifications';
import type { FilterConfig, FilterValues } from 'types';
import { useQuery } from 'react-query';
import {
  type GetParRateFormulaListbyCriteriaParams,
  type ParRateFormulaResponse,
  deleteParRateFormula,
  getParRateFormulaListbyCriteria,
} from 'services/parametersService';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IBasket from 'icons/IBasket';
import { AuthContext } from 'components/Auth/Auth';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import type { TableRowSelection } from 'antd/es/table/interface';

export type ParRateFormulasListProps = {
  color: string;
};

const ParRateFormulasList = (props: ParRateFormulasListProps) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedRow, setSelectedRow] = useState<ParRateFormulaResponse | null>(
    null
  );
  const [selectedRowKey, setSelectedRowKey] = useState<React.Key | null>(null);
  const [form] = useForm();
  const navigate = useNavigate();
  const { isInspect } = useContext(AuthContext);
  const [modalVisibleDelet, setmodalVisibleDelete] = useState(false);

  const [searchs, setsearchs] = useState(true);
  const [filterValues, setFilterValues] = useState<FilterValues>({});
  const getSearchParams = () => {
    return {
      formulalabel: filterValues.formulalabel || '',
      formulacode: filterValues.formulacode || '',
      formulastatus: '',
      formulatype: '',
      ratecode: '',
      ratelabel: '',
      formuladescription: '',
      //ratecodespread: 0,
      ratecodespread: filterValues.ratecodespread ?? undefined,

    };
  };

  const initialSearchParams: GetParRateFormulaListbyCriteriaParams =
    getSearchParams();
  const [SearchParams, SetSearchParams] =
    useState<GetParRateFormulaListbyCriteriaParams>(initialSearchParams);
  const {
    data: ParrateFormula,
    isFetching,
    refetch,
  } = useQuery(
    [' getParRateFormulaListbyCriteria,', SearchParams],
    () =>
      getParRateFormulaListbyCriteria(SearchParams).then(
        (res) => res.list || []
      ),
    { enabled: searchs }
  );

  const handleFilterSearch = (values: any) => {
    console.log('Filter values:', values);
    SetSearchParams(values);
  };

  const handleFilterReset = () => {
    setFilterValues({});
    form.resetFields();
  };
  const filterConfig: FilterConfig[] = [
    {
      key: 'formulacode',
      label: 'formulacode',
      type: 'text',
      placeholder: 'Nom',
    },
    {
      key: 'formulalabel',
      label: 'formulalabel',
      type: 'text',
      placeholder: 'description',
    },
  ];

  const columns = [
    {
      dataIndex: 'creationdate',
      key: 'creationdate',
      width: '100px',
      render: (text: string) => (
        <div style={{ paddingLeft: '12px' }}>{text}</div>
      ),
    },
    {
      dataIndex: 'formulacode',
      width: '100px',
      key: 'formulacode',
      render: (text: string) => (
        <div style={{ paddingLeft: '12px' }}>{text}</div>
      ),
    },
    {
      dataIndex: 'formulalabel',
      key: 'formulalabel',
      width: '200px',
      render: (text: string) => (
        <div style={{ paddingLeft: '12px' }}>{text}</div>
      ),
    },
    {
      dataIndex: 'product',
      key: 'product',
      width: '300px',
      render: (text: string) => (
        <div style={{ paddingLeft: '12px' }}>{text}</div>
      ),
    },
    {
      title: '',
      key: 'arrow',
      width: '80px',
      render: (record: ParRateFormulaResponse) => (
        <RightOutlined
          onClick={() =>
            navigate(`/configuration-sfs/rateformula/${record.formulacode}`)
          }
        />
      ),
      onHeaderCell: () => ({
        style: { paddingLeft: '12px' },
      }),
    },
  ];

  const onSelectChange = (
    selectedRowKeys: React.Key[],
    selectedRows: ParRateFormulaResponse[]
  ) => {
    if (selectedRows.length > 0) {
      const lastSelected = selectedRows[selectedRows.length - 1];
      setSelectedRow(lastSelected);
      setSelectedRowKey(lastSelected.formulacode);
      setIsDisabled(false);
    } else {
      setSelectedRow(null);
      setSelectedRowKey(null);
      setIsDisabled(true);
    }
  };

  const rowSelection: TableRowSelection<ParRateFormulaResponse> = {
    type: 'checkbox' as const,
    selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
    onChange: onSelectChange,
    onSelect: (record: ParRateFormulaResponse, selected: boolean) => {
      if (selected) {
        setSelectedRow(record);
        setSelectedRowKey(record.formulacode);
        setIsDisabled(false);
      } else {
        setSelectedRow(null);
        setSelectedRowKey(null);
        setIsDisabled(true);
      }
    },
  };

  const handleDelete = () => {
    if (selectedRow) {
      deleteParRateFormula({
        formulacode: selectedRow.formulacode,
      }).then((response) => {
        if (response.code === '200') {
          Notifications({
            status: 'success',
            message: response.message,
            description: response.description,
            duration: 2,
            placement: 'top',
          });
          setSelectedRow(null);
          setSelectedRowKey(null);
          setIsDisabled(true);
          refetch();
          
        } else {
          Notifications({
            status: 'error',
            message: response.message,
            description: response.description,
            duration: 2,
            placement: 'top',
          });
        }
      });
      !isInspect && setmodalVisibleDelete(false);
    }
  };

  return (
    //<DF.Provider pagcode="parrate">
    <DF.Provider pagcode="productlist">
      <div className="bg-color-gray">
        <HeroTitle
          form={form}
          color={props.color}
          title="parrateFormulaslist"
          showFilter={true}
          display
          filterConfig={filterConfig}
          onFilterSearch={handleFilterSearch}
          onFilterReset={handleFilterReset}
          className="productlist"
          noTitleOverlay
        />

        <div className="ut-title-page no-after">
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: '15px' }}
          >
            <Col className="d-flex justify-start align-center">
              <Button
                disabled={isDisabled}
                className={
                  !isDisabled
                    ? 'no-border-radius btn-header ant-btn-outline-primary bg-color-hover'
                    : 'no-border-radius  btn-header '
                }
                icon={
                  <IBasket
                    color={isDisabled ? '#d9d9d9' : '#dd7248'}
                    className="font-size-25"
                    onClick={() => {
                      isInspect && setmodalVisibleDelete(true);
                    }}
                  />
                }
                onClick={() => {
                  !isInspect && setmodalVisibleDelete(true);
                }}
              >
                <GetLabel label="deletrateFormulas" /> ({selectedRow ? 1 : 0})
              </Button>

              <Button
                className="no-border-radius ant-btn-outline-primary ml-2 filter-item  btn-header bg-color-hover"
                icon={<PlusOutlined onClick={() => isInspect} />}
                onClick={() =>
                  !isInspect &&
                  navigate(`/configuration-sfs/rateformula/create`)
                }
              >
                <GetLabel label="addrateFormula" />
              </Button>
            </Col>
            <Col span={5} className="d-flex justify-end align-center">
              <Button
                onClick={() => {}}
                className="ut-reset-btn ut-btn-no-border no-box-shadow"
                icon={<DownloadOutlined />}
              >
                <GetLabel
                  label="Exporter(.xls)"
                  className="color-blue font-weight-500"
                />
              </Button>
            </Col>
          </Row>
          
          <DataGrid
            columns={columns}
            dataSource={ParrateFormula}
            rowKey="formulacode"
            hideFilters
            hideTitle
            rowSelection={rowSelection}
            pagination={{
              pageSize: 10,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} sur ${total}`,
              showSizeChanger: true,
            }}
            className="no-border-radius"
            isLoading={isFetching}
          />
        </div>
        <ConfirmModal
          className="modalConfirmOrCancel"
          visible={modalVisibleDelet}
          status="error"
          message="Êtes-vous sûr de vouloir supprimer cette formule ?"
          onConfirm={handleDelete}
          onCancel={() => {
            !isInspect && setmodalVisibleDelete(false);
          }}
          Confirmcomcode="valider"
          Cancelcomcode="close"
        />
      </div>
    </DF.Provider>
  );
};

export default ParRateFormulasList;
